const externalCME = {
    // craft site id: [satellite.root_id,satellite.root_id,satellite.root_id]
    47: [125954],
}

export default externalCME
